import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=1e6c8c9b&scoped=true"
import script from "./WorkDetails.vue?vue&type=script&lang=js"
export * from "./WorkDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=1e6c8c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c8c9b",
  null
  
)

export default component.exports